import {
  FETCH_START,
  FETCH_ERROR,
  FETCH_SUCCESS,
  DB_LIST_USERS,
  DB_GET_USER,
  DB_USERS_ORG
} from "constants/ActionTypes"

import axiosDB from 'util/ApiDB'
import setupAxiosInterceptors from "appRedux/actions/setupAxiosInterceptors";

export const ActionUsersList = () => {
  return (dispatch, getState) => {
    dispatch({type: FETCH_START})

    const {access_token} = getState().auth;

    axiosDB.post('user/list', {}, {
      headers: { Authorization: `Bearer ${access_token}` }
    }).then(({data}) => {
      const users = data.response.users;

      const stateUpdateUsers = (users, dispatch) => new Promise((resolve, reject) => {
        dispatch({type: DB_LIST_USERS, payload: {users: users}})
        resolve()
      })

      stateUpdateUsers(users, dispatch).then(()=>{
        dispatch({ type: FETCH_SUCCESS });
      })
    }).catch(function (error) {
      dispatch({type: FETCH_ERROR, payload: error.message});
      console.log("Error****:", error.message);
    });
  }
}

export const ActionUsersGet = (rid) => {
  return (dispatch, getState) => {
    dispatch({type: FETCH_START})

    const {access_token} = getState().auth;

    axiosDB.post('user/get/' + rid, {}, {
      headers: { Authorization: `Bearer ${access_token}` }
    }).then(({data}) => {
      dispatch({type: DB_GET_USER, payload: {
        user: data.response.user
      }})
      dispatch({ type: FETCH_SUCCESS })
    }).catch(function (error) {
      dispatch({type: FETCH_ERROR, payload: error.message});
      console.log("Error****:", error.message);
    });
  }
}

export const ActionUsersReset = () => {
  return (dispatch) => {
    dispatch({type: DB_GET_USER, payload: {client: null}})
  }
}

export const ActionUsersAdd = (formData) => {
  return (dispatch, getState) => {
    dispatch({type: FETCH_START})

    const {access_token} = getState().auth;

    axiosDB.post('user/add', {
      formData: formData
    }, {
      headers: { Authorization: `Bearer ${access_token}` }
    }).then(({data}) => {
      dispatch(ActionUsersList())
    }).catch(function (error) {
      dispatch({type: FETCH_ERROR, payload: error.response.data.message});
      console.log("Error****:", error.message);
    });
  }
}

export const ActionUsersUpdate = (formData) => {
  return (dispatch, getState) => {
    dispatch({type: FETCH_START})

    const {access_token} = getState().auth;
    const {db_curr_user} = getState().system.users;

    axiosDB.post('user/update/' + db_curr_user.id, {
      formData: formData
    }, {
      headers: { Authorization: `Bearer ${access_token}` }
    }).then(({data}) => {
      dispatch(ActionUsersList())
    }).catch(function (error) {
      dispatch({type: FETCH_ERROR, payload: error.response.data.message});
      //console.log("Error****:", error.message);
    });
  }
}

export const ActionUsersDelete = (rid) => {
  return (dispatch, getState) => {
    dispatch({type: FETCH_START})
    
    const {access_token} = getState().auth;

    axiosDB.post('user/delete/' + rid, {}, {
      headers: { Authorization: `Bearer ${access_token}` }
    }).then(({data}) => {
      dispatch(ActionUsersList())
    }).catch(function (error) {
      dispatch({type: FETCH_ERROR, payload: error.message});
      console.log("Error****:", error.message);
    });
  }
}

export const ActionUsersByOrganisation = (oid) =>{
  return (dispatch, getState) => {
    dispatch({type: FETCH_START})

    const request = setupAxiosInterceptors(axiosDB, dispatch, getState);

    request.get('user/' + oid + '/orgainsation').then(({data}) => {
      dispatch({type: DB_USERS_ORG, payload: {
        users: data.response.users
      }})
      dispatch({ type: FETCH_SUCCESS })
    }).catch(function (error) {
      dispatch({type: FETCH_ERROR, payload: error.message});
      console.log("Error****:", error.message);
    });
  }
}